import React from "react";
import LoadingSpinner from "src/shared/LoadingSpinner";
import "./EntityAuditTrail.scss";
import { EntityChangeModel } from "./types";

interface EntityAuditTrailProps {
  audits: EntityChangeModel[] | null;
}

export const EntityAuditTrail: React.SFC<EntityAuditTrailProps> = ({
  audits
}) => {
  if (audits === null) {
    return <LoadingSpinner />;
  }
  if (audits.length === 0) {
    return <div className="EntityAuditTrail__empty">No changes.</div>;
  }
  return (
    <div className="EntityAuditTrail">
      {audits.reverse().map(change => (
        <div
          className="EntityAuditTrail__item"
          key={change.editedTime + change.newValue}
        >
          <div className="EntityAuditTrail__item--column-name">
            {change.column.toLowerCase() + " Change"}
          </div>
          <div className="EntityAuditTrail__container">
            <div className="EntityAuditTrail__item--new-value">
              <span className="EntityAuditTrail__item--bold">New Value: </span>
              <span className="EntityAuditTrail__item--value">
                {change.newValue}
              </span>
            </div>
            <div className="EntityAuditTrail__item--edited-by">
              Edited By: {change.editedBy}
            </div>
          </div>
          <div className="EntityAuditTrail__container">
            <div className="EntityAuditTrail__item--previous-value">
              <span className="EntityAuditTrail__item--bold">
                Previous Value:{" "}
              </span>
              <span className="EntityAuditTrail__item--value">
                {change.previousValue}
              </span>
            </div>
            <div className="EntityAuditTrail__item--last-edited">
              Last Updated: {change.editedTime}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/entityView/EntityAuditTrail.tsx